import React, { useState } from "react";
import useTranslation from "next-translate/useTranslation";

import {
  Box,
  Text,
  Flex,
  FormControl,
  Input,
  FormErrorMessage,
  Button,
  useToast,
} from "@chakra-ui/react";

import { subscribeUser } from "@strapi-newsletter/react";
import { Spinner } from "@chakra-ui/react";

import { configFile } from "@/config";

function SubscribeBlogBlock() {
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const { t } = useTranslation("common");

  const handeSubscribeSubmit = async (e: any) => {
    e.preventDefault();

    if (!(e.target.email.value === "")) {
      setIsLoading(true);
      try {
        await subscribeUser(
          e.target.email.value,
          `${process.env.NEXT_PUBLIC_API_URL}`
        );
        toast({
          title: "Thank you.",
          description: "We've received your email address.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        toast({
          title: "Error!",
          description: "Probably you have already subscribed.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } else {
      setIsError(e.target.email.value === "");
    }
  };

  return (
    <Box width="100%" position="relative">
      <Text fontWeight="700" fontSize="18px" mb="12px">
        {t("article.newsletter.title")}
      </Text>
      <Flex
        width="100%"
        flexDir="column"
        bgColor="#fff"
        flexWrap="wrap"
        justifyContent="center"
        alignItems="center"
        boxShadow="0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)"
        borderRadius="8px"
        padding="28px"
      >
        <Flex flexDirection="column" w="100%">
          <Text
            lineHeight="1.56"
            fontWeight="400"
            fontSize="18px"
            color="gray.500"
            textAlign="left"
            mb="24px"
          >
            {t("article.newsletter.text")}
          </Text>
          <form
            style={{ width: "100%", textAlign: "center" }}
            onSubmit={(e) => handeSubscribeSubmit(e)}
          >
            <FormControl isInvalid={isError}>
              <Input
                variant="Outline"
                size="lg"
                width="100%"
                border="1px solid #E2E8F0;"
                name="email"
                placeholder={t("article.newsletter.inputPlaceholder")}
                type="email"
                autoComplete="on"
              />
              {isError && (
                <FormErrorMessage mb="10px">Email is required.</FormErrorMessage>
              )}
            </FormControl>
            <Button
              aria-label='subscribe'
              mt="8px"
              size="lg"
              bgColor={configFile.primaryAccentColor}
              width="100%"
              fontWeight="600"
              color="#fff"
              type="submit"
              _hover={{ bgColor: configFile.tertiaryAccentColor }}
            >
              Inscrever-se
            </Button>
            {isLoading && (
              <Spinner
                margin=" 0 auto"
                mt="15px"
                color={configFile.primaryAccentColor}
              />
            )}
          </form>
        </Flex>
      </Flex>
    </Box>
  );
}

export default SubscribeBlogBlock;
